export enum PalletState {
	Good = "Good",
	Warning = "Warning",
	Alarm = "Alarm",
}
